export const environment = {
  production: false,
  backendUrl: "https://backend-test.badminton-toernooi.nl",
};
